// extracted by mini-css-extract-plugin
export default {"root":"BulkUpdateInstructorsModal_root__Up+g6","heading":"BulkUpdateInstructorsModal_heading__ZezcV","sectionHeading":"BulkUpdateInstructorsModal_sectionHeading__9r9Q-"};